import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StripePackagesModal from './stripe-packages-modal';

const SubscribedLink = ({ to, children, className, as = "a", onAllowed }) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    // 1. Initialize user state from localStorage
    const [user, setUser] = useState(() => {
        const storedUser = localStorage.getItem('@roampays-user');
        return storedUser ? JSON.parse(storedUser) : null;
    });

    // 2. Listen for the custom subscription event
    useEffect(() => {
        const updateSubscriptionState = () => {
          //  alert("Subscription status updated, refreshing...");
            const freshUser = localStorage.getItem('@roampays-user');
            setUser(freshUser ? JSON.parse(freshUser) : null);
        };

        // Listen for the event locally
        window.addEventListener('user-subscribed', updateSubscriptionState);

        return () => {
            window.removeEventListener('user-subscribed', updateSubscriptionState);
        };
    }, []);

    const isSubscribed =
        user &&
        user.stripe_package !== null &&
        user.stripe_package > 0;

    const handleClick = (e) => {
        e.preventDefault();

        if (!isSubscribed) {
            setIsOpen(true);
            return;
        }

        if (to) {
            navigate(to);
            return;
        }

        if (onAllowed) {
            onAllowed();
        }
    };

    const Wrapper = as === "a" ? "a" : "span";

    return (
        <>
            <Wrapper
                href={as === "a" ? to : undefined}
                onClick={handleClick}
                className={className}
                style={as !== "a" ? { display: "inline-block" } : undefined}
            >
                {children}
            </Wrapper>

            <StripePackagesModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </>
    );
};

export default SubscribedLink;